module.exports = __webpack_public_path__ + "img/blog_study_top.5bcd25d8.jpg";